import React, { useEffect, useState } from 'react';
import { Field } from 'react-final-form';
import _ from 'lodash';
import QCXFinalFieldWrapper from '../../final-field/QCXFinalFieldWrapper';
import QCXTextField from '../../text-field/QCXTextField';

const formatDecimal = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const number = parseFloat(value);
  return Number.isNaN(number) ? value : number.toFixed(5);
};

const parseDecimal = (value) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? value : parsed;
};

export default function ValorReal({ metadado, isConsult, codAtributoPai, basePath = '', ...restProps }) {
  const [label, setLabel] = useState('');
  const [name, setName] = useState('');
  const [codigo, setCodigo] = useState('');

  useEffect(() => {
    if (!metadado) return;

    setCodigo(metadado.codigo || '');
    setLabel(`${metadado.descricaoCodigo} (${metadado.codigo})` || '');
    setName(`${basePath}.${metadado.codigo}.valor` || '');
  }, [metadado, basePath]);

  if (!name) {
    return null;
  }

  return (
    <QCXFinalFieldWrapper
      label={label}
      name={name}
      component={QCXTextField}
      type="number"
      step="0.00001"
      disabled={isConsult}
      format={formatDecimal}
      parse={parseDecimal}
    formatOnBlur
    />
  );
}
